import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgKgCardTypeProduct = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "none",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 2,
		d: "m12 2.489 3.09 6.262L22 9.755l-5 4.874 1.18 6.882-6.18-3.25-6.18 3.25L7 14.629 2 9.755l6.91-1.004L12 2.489z"
	})
});
export default SvgKgCardTypeProduct;
